import { Component, Input, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI }       from 'ng-block-ui';
import { NgForm }                   from '@angular/forms';
import { UIRouter }                 from '@uirouter/core';

import { CodeTypeModel }    from '../../app-lite/core/models/code-type';
import { JsonService }      from '../../app-lite/core/services/json.service';
import { MessagesService }  from '../../app-lite/messages/messages.service';
import { UserModel }        from '../../app-lite/users/models/user';
import { XeroCompanyModel } from '../../app-lite/xero/models/xero.company';
import { XeroService }      from '../../app-lite/xero/xero.service';
import { XeroTokensModel }  from '../../app-lite/xero/models/xero.tokens';

@Component({
  selector   : 'wor-xero-signup',
  template: require('./xero.signup.component.html')
})
export class XeroSignupComponent implements OnInit {
  @BlockUI('xeroSignupBlock') block : NgBlockUI;

  @Input() code      : string;
  @Input() countries : Array<CodeTypeModel>;

  tokens: XeroTokensModel;
  user  : UserModel = {};

  constructor (
    private jsonService    : JsonService,
    private messagesService: MessagesService,
    private router         : UIRouter,
    private xeroService    : XeroService
  ) {}

  init () : void {
    if ( this.xeroService.needsAuthentication() ) {
      this.block.start();

      window.location.assign(this.xeroService.getAuthenticationUrl());
    }
    else {
      this.block.start();

      this.user.country = this.jsonService.getQueryParameters().country;

      this.xeroService.getSignupTokens()
      .then(( tokens : XeroTokensModel ) => {
        this.tokens = tokens;

        if ( !this.tokens.access_token ) {
          this.router.stateService.go('app.xero-signup', {
            code: null
          }, {
            reload: false
          });
        }

        return this.xeroService.getUserForSignup(this.tokens);
      })
      .then(( user : UserModel ) => {
        this.user = user;
      })
      .catch(error => this.messagesService.error(error))
      .finally(() => this.block.stop());
    }
  }

  ngOnInit () : void {
    this.init();
  }

  submit ( form : NgForm ) {
    let company : XeroCompanyModel;

    this.block.start();

    this.xeroService.signup(this.user)
    .then(( result : XeroCompanyModel ) => {
      company = result;

      return this.xeroService.grantAccess(company, this.tokens);
    })
    .then(( code : string ) => this.xeroService.login(company, code))
    .then(( url : string ) => window.location.assign(url))
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}